import { render, staticRenderFns } from "./AdminIndex.vue?vue&type=template&id=765767d7&scoped=true&"
import script from "./AdminIndex.vue?vue&type=script&lang=ts&"
export * from "./AdminIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765767d7",
  null
  
)

export default component.exports